import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Hero from "../../components/Careers/Hero"
import WorkTravel from "../../components/Careers/WorkTravel"
import Training from "../../components/Careers/Training"
import SkillFactory from "../../components/Careers/SkillFactory"
import HealthWellness from "../../components/Careers/HealthWellness"
import AvalithTime from "../../components/Careers/AvalithTime"
import MoreBenefits from "../../components/Careers/MoreBenefits"

const Careers = () => {
  return (
    <Layout>
      <SEO title="Careers" />
      <Hero />
      <WorkTravel />
      <Training />
      <SkillFactory />
      <HealthWellness />
      <AvalithTime />
      <MoreBenefits />
    </Layout>
  )
}

export default Careers
